import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { TextField } from '../../../shared/TextField';
import { ErrorMessage } from 'formik';
import { injectIntl } from 'react-intl';
import { SelectField } from "../../../shared/SelectField";
import { COUPON_INDIVIDUAL, COUPON_TYPE } from "../../../../config/constants/Campaign/campaign_constants";
import { Table } from "./productTable/Table";
import { FieldMessages } from "../../../layout/Messages/FieldMessages";
import { NOTIFICATION_CREATE_COUPON } from "../../../../config/notifications";

function CouponInfoComponent(props) {
  const { formikProps, initialValues, setInitialValues, updateFormikProps } = props;
  const [ type, setType ] = useState(COUPON_TYPE[0]);

  const getErrorClass = (formikProps, fieldName) => {
    return formikProps && formikProps.touched && formikProps.touched[fieldName] ? formikProps.errors && formikProps.errors[fieldName] !== undefined ? 'custom-is-invalid' : '' : '';
  }

  if (formikProps && formikProps.values && typeof formikProps.values.type !== 'number') {
    setType(COUPON_TYPE[0]);
    formikProps.setFieldValue("type", COUPON_TYPE[0].value);
  }

  return (<div className="campaign-coupon-info">
    <Row>
      <Col xs={ 12 } sm={ 4 }>
        <label className='form-control-label d-block'>
          <FormattedMessage id="fields.campaignManagement.no_of_coupons"/>
        </label>
        <TextField
          name="campaignManagement.no_of_coupons"
          handleBlur={ formikProps.handleBlur }
          fontAwesome="faBuilding"
          onChange={ event => {
            formikProps.setFieldValue('no_of_coupons', event.target.value);
          }}
          value={ formikProps.values.no_of_coupons }
          errorClass={ getErrorClass(formikProps, 'no_of_coupons') }
        />
        <FieldMessages
          color="danger"
          formikProps={ formikProps }
          class="small-field-error"
          showDismiss={ false }
          name="no_of_coupons"
          notificationId={ NOTIFICATION_CREATE_COUPON }
        >
          <ErrorMessage
            name="no_of_coupons"
            component="div"
            data-testid="errors-no_of_coupons"
            className="no-input-margin"
          />
        </FieldMessages>
      </Col>
      <Col xs={ 12 } sm={ 4 } className="justify-content-between">
        <label className='form-control-label d-block'>
          <FormattedMessage id="fields.campaignManagement.prefix"/>
        </label>
        <TextField
          name="campaignManagement.prefix"
          handleBlur={ formikProps.handleBlur }
          fontAwesome="faBuilding"
          onChange={ event => {
            formikProps.setFieldValue('prefix', event.target.value);
          } }
          value={ formikProps.values.prefix || "" }
          errorClass={ getErrorClass(formikProps, 'prefix') }
        />
        <FieldMessages
          color="danger"
          formikProps={ formikProps }
          class="small-field-error"
          showDismiss={ false }
          name="prefix"
          notificationId={ NOTIFICATION_CREATE_COUPON }
        >
          <ErrorMessage
            name="prefix"
            component="div"
            data-testid="errors-prefix"
            className="no-input-margin"
          />
        </FieldMessages>
      </Col>
      <Col xs={ 12 } sm={ 4 }>
        <label className='form-control-label d-block'>
          <FormattedMessage id="fields.campaignManagement.type"/>
        </label>
        <SelectField
          name="type"
          className="mb-4"
          classNamePrefix="ml-0"
          defaultValue={ type }
          options={ COUPON_TYPE }
          onChange={
            option => {
              formikProps.setFieldValue("type", option.value);
              if (option.value === COUPON_INDIVIDUAL) {
                formikProps.setFieldValue("coupon_products", [formikProps.values.coupon_products[0]]);
              }

              setType(option);
            }
          }
          formikProps={ formikProps }
          getErrorClass={ getErrorClass }
        />
        <FieldMessages
          color="danger"
          formikProps={ formikProps }
          class="small-field-error"
          showDismiss={ false }
          name="type"
          notificationId={ NOTIFICATION_CREATE_COUPON }
        >
          <ErrorMessage
            name="type"
            component="div"
            data-testid="errors-type"
            className="no-input-margin"
          />
        </FieldMessages>
      </Col>
    </Row>
    <Row>
      <Col>
        <Table
          formikProps={ formikProps }
          initialValues={ initialValues }
          setInitialValues={ setInitialValues }
          updateFormikProps={ updateFormikProps }
        />
      </Col>
    </Row>
  </div>)
}

const CouponInfo = injectIntl(CouponInfoComponent);

export { CouponInfo, CouponInfoComponent }
